import * as vehicleTypes from 'commons-vehicle/Vehicle/actions/vehicleActionTypes.js';

import { ConfigsService, WindowProxy } from '@sm360/widget-commons-core-services';
import { EVENTS } from '@sm360/widget-commons-general';
import { LeadSubmissionBuilder, LEAD_TYPES } from '@sm360/widget-commons-leads';
import QuoteService from 'commons-vehicle/Quote/services/QuoteService/QuoteService.js';
import LeadTypes from 'commons-vehicle/Quote/constants/leadTypes.js';
import ModelYearActions from 'commons-vehicle/ModelYear/actions/modelYearActions.js';

import { setQuoteV25, setQuoteError, setQuote } from '../../Quote/actions/quoteActions.js';
import AddToGarageV25 from '../../Quote/components/AddToGarageV25/AddToGarageV25.jsx';

import ShowroomService from '../../services/ShowroomService/ShowroomService.js';

function dispatchAddToGarage() {
    const $window = WindowProxy.get();
    if ($window) {
        $window.document.dispatchEvent(new Event(EVENTS.GARAGE_ADDED));
    }
}

export function setVehicle(vehicle) {
    return { type: vehicleTypes.SET_VEHICLE, vehicle };
}

export function setPurchaseMethods(purchaseMethods) {
    return { type: vehicleTypes.SET_VEHICLE_PURCHASE_METHODS, purchaseMethods };
}

export function saveToGarageV25(vehicle) {
    return (dispatch, getState) => {
        const location = ConfigsService.getOrganizationUnitLocation();
        const state = getState();

        // Ensure the vehicle is stored in the quote
        dispatch(setQuoteV25(QuoteService.resetQuoteFromVehicleV25(state.quoteV25, location, vehicle)));

        const addToGarageV25 = new AddToGarageV25();

        addToGarageV25
            .addOrUpdateQuote(state.quoteV25)
            .then((quoteId) => {
                return new Promise((resolve) => {
                    let tries = 0;
                    const interval = setInterval(
                        () =>
                            ShowroomService.searchQuoteV25(quoteId)
                                .then((updatedQuote) => {
                                    if (updatedQuote.leadId) {
                                        dispatch(setQuoteV25(updatedQuote));
                                        addToGarageV25.dispatchAddToGarage();
                                        return updatedQuote.leadId;
                                    }
                                    return undefined;
                                })
                                // eslint-disable-next-line consistent-return
                                .then((leadId) => {
                                    if (tries > 5 || leadId) {
                                        clearInterval(interval);
                                        resolve(quoteId);
                                    }
                                    tries += 1;
                                }),
                        2000
                    );
                });
            })
            .then((quoteId) => {
                // Update quote since for an appointment widget we need both quoteV25 and quote updated
                ShowroomService.loadQuote(quoteId).then((quote) => {
                    dispatch(setQuote(quote));
                });
            })
            .catch((error) => {
                dispatch(setQuoteError(error?.message));
            });
    };
}

export function saveToGarage() {
    return (dispatch, getState) => {
        const location = ConfigsService.getOrganizationUnitLocation().toLowerCase();

        let state = getState();

        const { quote } = state;
        // Remove id and accountId to convert public quote to private
        const newQuote = quote.set('id', '').set('accountId', '');
        dispatch(
            setQuote(
                QuoteService.resetQuoteFromModelYear(newQuote, location, LeadTypes.SAVE_TO_GARAGE, state.modelYear)
            )
        );

        state = getState();

        return ShowroomService.saveQuote(newQuote.getShowroomQuote()).then((showroomQuote) => {
            const mappedQuote = QuoteService.resetQuoteFromShowroomSave(newQuote, showroomQuote);

            dispatchAddToGarage();

            if (QuoteService.quoteHasVehicle(mappedQuote)) {
                const leadRequest = new LeadSubmissionBuilder()
                    .addLeadType(LEAD_TYPES.ACCOUNT_CREATION)
                    .addQuote(mappedQuote)
                    .addVehicle(mappedQuote);

                leadRequest.submit();

                setTimeout(
                    () =>
                        ShowroomService.loadQuote(mappedQuote.id).then((reloadedQuote) =>
                            dispatch(setQuote(reloadedQuote))
                        ),
                    2000
                );
            } else {
                dispatch(setQuote(mappedQuote));
            }

            return true;
        });
    };
}

export function loadModelYears(modelYearsParams, tradeInVehicleParams, initialLoad) {
    return (dispatch) => {
        dispatch(ModelYearActions.loadModelYears(modelYearsParams, tradeInVehicleParams, initialLoad));
    };
}

export default {
    setVehicle,
    setPurchaseMethods,
    saveToGarageV25,
    saveToGarage,
    loadModelYears,
};
